module.exports = __webpack_public_path__ + "f5460ae1cd27b777ea459d8ea12d7895.jpg";